<template>
  <div class="v-counter style-two">
    <button class="plusBtn" @click="decrement"></button>
    <input 
      type="text" 
      size="25" 
      :value="modelValue" 
      class="count" 
      @input="onInput"
    />
    <button class="minusBtn" @click="increment"></button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "QuantityCounter",
  props: {
    modelValue: {
      type: Number,
      default: 1
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const increment = () => {
      emit("update:modelValue", props.modelValue + 1);
    };

    const decrement = () => {
      if (props.modelValue > 1) {
        emit("update:modelValue", props.modelValue - 1);
      }
    };

    const onInput = (e: Event) => {
      const val = parseInt((e.target as HTMLInputElement).value);
      if (!isNaN(val) && val >= 1) {
        emit("update:modelValue", val);
      }
    };

    return {
      increment,
      decrement,
      onInput
    };
  },
});
</script>